module.exports = __webpack_public_path__ + "static/media/Pokédex_logo.6f1fd446.png";